module.exports = __webpack_public_path__ + "img/workout-notebook_B095Q83YBJ.3af5a0f3.jpg";